import React, { useState } from "react";

import { Table, Pagination } from "../../../components/shared";

import {
  AddIcon,
  DownloadIcon,
  FilterIcon,
  FilterIconWhite,
  UploadIcon,
} from "../../../assets";
import useSearchAndFilter from "../../../hooks/useSearchAndFilter";
import { Loader } from "../../../components/loaders/loaders";
import AddScas from "../../../components/modals/systemConfigurationModal/AddScac";
import FilterSideMenu from "../../../components/shared/FilterSideMenu";
import { Badge } from "@mui/material";
import { DEFAULT_PAGE_SIZE, DOWNLOAD_SCAC_LIST_URL } from "../../../utils/constants";
import UploadAgent from "../../../components/modals/UploadAgent";
import { SERVICE_CONFIG_MESSAGES } from "../../../utils/message";

interface OrderStatusResponse {
  id: string;
  count: number | string;
  active: boolean;
  orderStatus: {
    id: string;
    name: string;
    isActive: boolean;
  };
  dispatchTrackOrderStatus: string;
}

const columns = [
  { key: "count", header: "S.", isSortable: false, className: "count" },
  {
    key: "scac",
    header: "SCAC",
    isSortable: true,
    className: "dark",
  },
  {
    key: "carrier",
    header: "Carrier",
    isSortable: true,
    className: "dark",
  },
];

const mapUserData = (data: any) =>
  data.map((item: any) => ({
    id: item?.id,
    count: item?.count,
    scac: item?.scac || "",
    carrier: item?.name || "",
    active: item?.isActive === "0" ? false : true,
  }));

const tableConfig = {
  delete: {
    apiUrl: "/service/scac/delete/",
    urlID: "id",
    successMessage: SERVICE_CONFIG_MESSAGES.SCAC_DELETE_SUCCESS,
    heading: SERVICE_CONFIG_MESSAGES.SCAC_DELETE_HEADING,
    para: "delete",
    rowName: "scac",
    secondRowName: "",
    deleteByPutApi: false,
  },
};

interface AgentApiOrderStatusProps {
  apiData?: {
    agentId: string;
    agentHubId: string;
    orderDispatchCredId: string;
  };
  apiType?: {
    id: string;
    name: string;
  };
}

const Scac: React.FC<AgentApiOrderStatusProps> = ({ apiData, apiType }) => {
  const locationData = {
    id: "12345",
  };
  /**
   * Custom hook for fetching data, handling search, and managing pagination.
   *
   * @param apiUrl - The URL to fetch data from.
   * @param limit - The maximum number of items to fetch.
   * @param mapUserData - Function to map the fetched data.
   *
   * @returns data - The fetched data for display in the table.
   * @returns keyword - The current search keyword.
   * @returns loading - Boolean indicating if data is being loaded.
   * @returns setLoading - Function to set the loading state.
   * @returns handleKeywordChange - Function to handle changes in the search input and debounce API calls.
   * @returns fetchFilteredData - Function to fetch data based on the current filters.
   * @returns setData - Function to set the data.
   */
  const {
    data,
    loading,
    setLoading,
    fetchFilteredData,
    closeOpenfilterModal,
    isShowFilterModal,
    selectStatus,
    setSelectStatus,
    scac,
    setScac,
    carrier,
    setCarrier,
    filterApplied,
    setFilterApplied,
    refreshPage,
    fetchWithCurrentFilters,
    captureAppliedFilters,
    clearCurrentFilters,
  } = useSearchAndFilter<OrderStatusResponse>({
    apiUrl: "/service/scac",
    limit: DEFAULT_PAGE_SIZE,
    mapUserData,
    screenKey: "scac",
  });
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [modalType, setModalType] = useState<string>("Add");
  const [rowData, setRowData] = useState();
  const [uploadPopUp, setUploadPopUp] = useState<boolean>(false);
  const [popUpTitle, setPopUpTitle] = useState<string>("");

  const handleEditModal = (data: any) => {
    setModalType("Edit");
    setIsShowModal(true);
    setRowData(data);
  };

  return (
    <>
      <div
        className={`tableWrap ${
          isShowFilterModal ? "tableWrap--filterOpen" : ""
        }`}
      >
        <div className="tableWrap__head tableWrap__head--end">
          <>
            <a
              className="btn btn__white w_fitContent"
              target="_blank"
              rel="noreferrer"
              href={DOWNLOAD_SCAC_LIST_URL}
            >
              <DownloadIcon />
              Download SCAC Template
            </a>
            <button
              className="btn btn__white w_fitContent"
              onClick={() => {
                setUploadPopUp(true);
                setPopUpTitle("SCAC");
              }}
            >
              <UploadIcon />
              Import SCAC
            </button>
          </>
          <div className="btn__group">
            {filterApplied ? (
              <Badge badgeContent=" " color="primary">
                <button
                  className={
                    !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                  }
                  onClick={closeOpenfilterModal}
                >
                  {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                  Filter
                </button>
              </Badge>
            ) : (
              <button
                className={
                  !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                }
                onClick={() => {
                  // setShowEditColumn(false);
                  closeOpenfilterModal();
                }}
              >
                {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                Filter
              </button>
            )}
            <FilterSideMenu
              isShowFilterModal={isShowFilterModal}
              closeOpenfilterModal={closeOpenfilterModal}
              selectStatus={selectStatus}
              setSelectStatus={setSelectStatus}
              isStatusHide={true}
              isRoleHide={true}
              isOrderStatusHide={true}
              isOrderTypeHide={true}
              isAgentTypeHide={true}
              isHubHide={true}
              isServiceHide={true}
              isCustomerTypeHide={false}
              isAllCustomerTypeHide={true}
              showScac={true}
              scac={scac}
              setScac={setScac}
              carrier={carrier}
              setCarrier={setCarrier}
              showCarrier={true}
              fetchFilteredData={fetchFilteredData}
              onFiltersApplied={captureAppliedFilters}
              filterApplied={filterApplied}
              setFilterApplied={setFilterApplied}
              table="scac"
              clearFiltersFromStorage={clearCurrentFilters}
            />
            <button
              className="btn btn__white w_fitContent"
              onClick={() => {
                setModalType("Add");
                setIsShowModal(true);
              }}
            >
              <AddIcon />
              Create New
            </button>
          </div>
        </div>
        <Table
          columns={columns}
          data={data}
          setLoading={setLoading}
          // onDeleteConfig={tableConfig.delete}
          editModalHanlde={handleEditModal}
          getApiData={fetchWithCurrentFilters}
          disabledActive={true}
          deleteIcon={false}
          activeIcon={true}
          editIcon={true}
        />
        <Pagination />
      </div>
      {isShowModal && (
        <AddScas
          confirmModal={isShowModal}
          setConfirmModal={setIsShowModal}
          rowData={rowData}
          modalType={modalType}
          setLoading={setLoading}
          xceleratorId={locationData?.id}
          getApiData={fetchWithCurrentFilters}
          apiData={apiData}
          apiType={apiType}
        />
      )}
      {uploadPopUp && (
        <UploadAgent
          setConfirmModal={setUploadPopUp}
          popUpTitle={popUpTitle}
          changeStep={refreshPage}
        />
      )}
      {loading && <Loader />}
    </>
  );
};

export default Scac;
